export function formatTs(ts: number): string {
  if (!ts) return '—';
  const ms = ts < 2_000_000_000 ? ts * 1000 : ts; // tolerate unix-seconds or unix-ms
  const d = new Date(ms);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatDay(day: string): string {
  const d = new Date(`${day}T00:00:00`);
  if (Number.isNaN(d.getTime())) return day;
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

export function formatPct(fraction: number): string {
  return `${Math.round(fraction * 100)}%`;
}

export function relativeTime(ts: number): string {
  if (!ts) return 'never';
  const ms = ts < 2_000_000_000 ? ts * 1000 : ts;
  const diffSec = Math.round((Date.now() - ms) / 1000);
  if (diffSec < 60) return 'just now';
  const diffMin = Math.round(diffSec / 60);
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffHr = Math.round(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h ago`;
  const diffDay = Math.round(diffHr / 24);
  return `${diffDay}d ago`;
}
